import * as $ from 'jquery';
import 'bootstrap-datepicker';

$(document).on("focusin","input.datepicker", function () {
	$(this).datepicker({
		format: 'dd/mm/yyyy',
	});
});
